import Swiper from 'swiper';
import { A11y, Autoplay } from 'swiper/modules';

export default class LogoScroller {
    constructor() {
        document.querySelectorAll('.js-logo-scroller').forEach((root) => {
            const el = root.querySelector('.js-logo-scroller__swiper');

            if (!el) return;

            const config = {
                a11y: true,
                autoplay: {
                    delay: 0,
                    pauseOnMouseEnter: true,
                },
                direction: 'horizontal',
                loop: true,
                modules: [A11y, Autoplay],
                slidesPerView: 2,
                spaceBetween: 40,
                speed: 5000,
                breakpoints: {
                    768: {
                        slidesPerView: 4,
                    },
                    1024: {
                        slidesPerView: 6,
                    },
                },
            };

            this.padSlides(el, config);

            new Swiper(el, config);
        });
    }

    // Swiper only loops with comfortably more slides than the largest
    // slidesPerView (2x is the safe minimum for a seamless marquee). With fewer
    // logos than that the track sits static and left-aligned, so clone the set
    // until we clear the threshold. Clones are decorative repeats, so hide them
    // from assistive tech to avoid announcing each logo multiple times.
    padSlides(el, config) {
        const perViews = [config.slidesPerView, ...Object.values(config.breakpoints).map((bp) => bp.slidesPerView)];
        const minSlides = Math.max(...perViews) * 2;

        const wrapper = el.querySelector('.swiper-wrapper');
        const slides = Array.from(wrapper.children);

        if (!slides.length || slides.length >= minSlides) return;

        const extraSets = Math.ceil(minSlides / slides.length) - 1;

        for (let i = 0; i < extraSets; i++) {
            slides.forEach((slide) => {
                const clone = slide.cloneNode(true);
                clone.setAttribute('aria-hidden', 'true');
                wrapper.appendChild(clone);
            });
        }
    }
}
